export const biztalkTemplates: Record<
  string,
  {
    tmpltCode: string;
    getMessage: (params: {
      userName?: string;
      deviceName?: string;
      applyDate?: string;
      price?: string;
      reason?: string;
      application_id?: string;
      device_id?: string;
      returnTrackingNumber?: string;
      // 🆕 가격안내 단일 템플릿용 파라미터
      grade?: string;              // A/B/C/D 등급
      deductionReasonLine?: string; // 차감사유 라인 (있을 때만 표시)
      applicationNumber?: string;   // 신청번호
    }) => string;
    getTitle?: (params: {
      userName?: string;
      deviceName?: string;
      applyDate?: string;
    }) => string;
    link?: {
      url_mobile: string;
      url_pc: string;
      scheme_android: string;
      scheme_ios: string;
    };
    buttons?: {
      name: string;
      type: string;
      url_mobile?: string;
      url_pc?: string;
    }[];
  }
> = {
  // 1. 신청완료
  '신청완료': {
    tmpltCode: 'dw-apply-complete',
    getTitle: ({ userName }) => `${userName}님, 신청 접수 완료`,
    getMessage: ({ deviceName, applyDate }) => `
[다원트레이드]
- 신청기기: ${deviceName}
- 접수일자: ${applyDate}

CJ대한통운 택배기사가 방문 수거할 예정이며, 포장후 박스에 "다원트레이드"라고 적어서 전달 해주세요.

기기 파손 방지를 위해 꼭 완충재를 동봉해 주세요.
검수 후 보상 금액이 안내될 예정입니다.`,
    link: {
      url_mobile: 'https://event.dwt.kr',
      url_pc: 'https://event.dwt.kr',
      scheme_android: 'https://event.dwt.kr',
      scheme_ios: 'https://event.dwt.kr',
    },
  },

  // 2. 택배접수
  '택배접수': {
    tmpltCode: 'dw-tracking-received',
    getMessage: ({ applyDate }) => `
[다원트레이드]
고객님의 방문 택배 접수가 완료되었습니다.

CJ대한통운 택배기사가 영업일 기준 2~3일 이내 방문할 예정입니다.
기기 파손을 방지하기 위해 완충제를 반드시 동봉해 주시고,
박스 포장을 꼼꼼히 해주시기 바랍니다.

감사합니다.`,
  },

  // 3. 입고완료
  '입고완료': {
    tmpltCode: 'dw-received',
    getTitle: ({ userName }) => `${userName}님 입고완료`,
    getMessage: ({ userName }) => `
안녕하세요.
${userName}님 ‘다원트레이드’로 보내주신 택배가 정상 입고되었습니다.
검수는 영업일 기준 2~3일 소요될 수 있으며 검수 완료시 결과를 알림톡으로 발송해드립니다.
조금만 여유를 가지고 기다려주시면 감사드리겠습니다.

▶ 검수 완료 예상일 : 수거완료일로부터 2~3일 이내 (영업일 기준)`,
  },

  // 4. 검수중
  '검수중': {
    tmpltCode: 'dw-inspection-started',
    getMessage: () => `
[다원트레이드]
고객님께서 보내주신 기기에 대해 검수가 진행 중입니다.

검수가 완료되면 보상 금액을 안내드리겠습니다.`,
  },

  // 5. 가격안내 - 단일 템플릿 (A/B/C/D 등급 공통)
  // 🎯 기존 베스트/굿/리페어 3개 템플릿을 A/B/C/D 4등급 단일 템플릿으로 통합
  '가격안내': {
    tmpltCode: 'dw-price-notice',
    getMessage: ({ applicationNumber, deviceName, grade, deductionReasonLine, price }) => {
      // 차감사유 라인: 값이 있을 때만 표시
      const reasonLine = deductionReasonLine ? `${deductionReasonLine}\n` : '';
      return `[다원트레이드]
검수 결과 및 보상금액 안내드립니다.

신청번호 : ${applicationNumber || '-'}
신청 기기 : ${deviceName || '-'}
등급 : ${grade || '-'}
${reasonLine}
총 보상금액 : ${price || '0'}원

최고가로 정직하게 평가해 드리니 안심하고 진행해 주세요.
감사합니다!`;
    },
    buttons: [
      {
        name: '입금 신청',
        type: 'WL',
        url_mobile: 'https://event.dwt.kr/accept/#{application_id}?device_id=#{device_id}',
        url_pc: 'https://event.dwt.kr/accept/#{application_id}?device_id=#{device_id}',
      },
      {
        name: '반송 신청',
        type: 'WL',
        url_mobile: 'https://event.dwt.kr/reject/#{application_id}?device_id=#{device_id}',
        url_pc: 'https://event.dwt.kr/reject/#{application_id}?device_id=#{device_id}',
      },
    ],
  },

  // 8. 매입 불가
  '매입 불가': {
    tmpltCode: 'dw-unpurchasable',
    getMessage: ({ deviceName, applyDate, returnTrackingNumber, reason }) => `
[다원트레이드]
- 신청기기: ${deviceName}
- 접수일자: ${applyDate}

고객님께서 신청하신 기기는 아래의 사유로 인해 매입이 불가합니다.
보내주신 기기는 금일 반송처리 진행될 예정입니다.

▶택배사 : CJ대한통운
▶반송장번호 : ${returnTrackingNumber || '처리 중'}
▶매입불가사유 : ${reason}

이용해주셔서 진심으로 감사합니다.
더 좋은 서비스로 보답하겠습니다.`,
  },

  // 9. 반송
  '반송': {
    tmpltCode: 'dw-return-completed',
    getMessage: ({ deviceName, applyDate, returnTrackingNumber }) => `
[다원트레이드]
- 신청기기: ${deviceName}
- 접수일자: ${applyDate}

고객님께서 신청하신 기기에 대한 반송이 정상적으로 완료되었습니다.

▶택배사 : CJ대한통운
▶반송장번호 : ${returnTrackingNumber || '처리 중'}

이용해주셔서 진심으로 감사합니다.
더 좋은 서비스로 보답하겠습니다.`,
    buttons: [
      {
        name: '배송조회',
        type: 'DS'
      }
    ],
  },

  // 10. 완료
  '완료': {
    tmpltCode: 'dw-deal-completed',
    getTitle: ({ userName }) => `${userName}님, 입금이 완료되었습니다`,
    getMessage: ({ deviceName, applyDate }) => `
[다원트레이드]
- 신청기기: ${deviceName}
- 접수일자: ${applyDate}

고객님께서 신청하신 기기에 대한 입금이 정상적으로 완료되었습니다.

이용해주셔서 진심으로 감사합니다.
더 좋은 서비스로 보답하겠습니다.
    `, link: {
      url_mobile: 'https://event.dwt.kr',
      url_pc: 'https://event.dwt.kr',
      scheme_android: 'https://event.dwt.kr',
      scheme_ios: 'https://event.dwt.kr',
    },
    buttons: [
      {
        name: '채널 추가',
        type: 'AC'
      }
    ],
  },

  // 11. 정보입력요청 - 거래처 전용 (아이즈모바일 위탁)
  '정보입력요청': {
    tmpltCode: 'dw-info-request-partner',
    getMessage: ({ userName, deviceName, applyDate }) => `안녕하세요, ${userName}님.

아이즈모바일을 통해 신청해 주신 중고기기 매입 접수가 완료되었습니다.

본 건은 아이즈모바일의 위탁을 받아 '다원트레이드'에서 수거, 검수, 보상 업무를 진행합니다.

[신청 정보]
- 신청기기: ${deviceName}
- 접수일자: ${applyDate}

[다음 단계 안내]
아래 버튼을 눌러 수거 주소와 입금 계좌를 입력해 주세요.
입력이 완료되면 CJ대한통운 택배기사가 2~3일 내 방문합니다.

[택배 발송 시 확인사항]
- 박스에 "아이즈모바일" 이라고 적어주세요
- 기기 보호를 위해 완충재(뽁뽁이 등)를 꼭 넣어주세요

문의사항은 다원트레이드 고객센터로 연락 부탁드립니다.
감사합니다.`,
    buttons: [
      {
        name: '정보 입력하기',
        type: 'WL',
        url_mobile: 'https://event.dwt.kr/customer/complete-info?token=#{token}',
        url_pc: 'https://event.dwt.kr/customer/complete-info?token=#{token}',
      },
    ],
  },
};
